module.exports = __webpack_public_path__ + "img/products-2.cb27b0d4.jpg";